module.exports = __webpack_public_path__ + "img/kompack-warehouse.39dfb46d.svg";